import Telefonliste from "../components/Telefonliste";
import Maschinenboerse from "../components/Maschinenboerse";
import Home from "../components/Home/Home";
import Start from "../components/Home/Start";
import Header from "../components/Header/Header";
import Bestellungen from "../components/Bestellungen";
import Meldungen from "../components/Meldungen";
import Login from "../components/Login/Login";
import Logout from "../components/Logout/Logout";
import Streckengeschaeft from "../components/Streckengeschaeft";
import Neukunden from "../components/Neukunden";
import Abrechnungen from "../components/Abrechnungen";
import Erzeuger from "../components/Erzeuger";
export const routes = [
    {path: "/", element: <Header/>,
        children: [
            {path: "/", element: <Home/>},
            {path: "home", element: <Home/>},
            {path: "telefonliste", element: <Telefonliste/>,},
            {path: "streckengeschaeft", element: <Streckengeschaeft/>,},
            {path: "maschinenboerse", element: <Maschinenboerse/>,},
            {path: "bestellungen", element: <Bestellungen/>,},
            {path: "abrechnungen", element: <Abrechnungen/>,},
            {path: "meldungen", element: <Meldungen/>,},
            {path: "meldungen/:kw/:jahr", element: <Meldungen/>,},
            {path: "Neukunden", element: <Neukunden/>,},
            {path: "gemuesegarten", element: <Neukunden/>,},
            {path: "einstellungen", element: <Erzeuger/>,},
            {path: "login", element: <Login/>,},
            {path: "logout", element: <Logout/>,},
            {path: "*", element: <Home/>,},
        ]
    },

];

export default routes;
